import styled from "styled-components";

export const StyledTableDaysRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: calc(1.8125rem / 3);
`;

export const StyledTableDaysCell = styled.div`/* ШАПКА календаря */
  width: 11rem;
  height: 2rem;
  text-align: center;
  line-height: 2rem;
  background-color: ${(props) =>
    props.theme.calendar.backgroundColors.dayOfWeekCell};
  color: ${(props) => props.theme.calendar.fontColors.day};
  font-size: 1.6rem;
  font-weight: 500;
  box-shadow: 0.3125rem 0.3125rem 0.3125rem 0px rgba(0, 0, 0, 0.3);
  filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.3));
`;
